import { useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import confetti from "canvas-confetti";
import { useNavigate } from "react-router-dom";
export default function OrderSuccess() {
  const { state } = useLocation();   
  const navigate = useNavigate();
  const noState = !state;

  // 🎉 Confetti SOLO si hay datos
useEffect(() => {
  if (!state) return; // <-- evita confetti en redirección

  setTimeout(() => {
    confetti({
      particleCount: 80,
      spread: 65,
      origin: { y: 0.3 },
    });
  }, 300);
}, [state]);

// 🔄 Redirigir si no hay datos
useEffect(() => {
  if (!state) {
    navigate("/");
  }
}, [state, navigate]);

// No mostrar nada mientras redirige
if (!state) return null;

  const { order, items, paymentMethod, totalUSD, total } = state;

  const pm = paymentMethod?.toLowerCase();
  const isColones = pm === "sinpe móvil" || pm === "transferencia bancaria";
  const isUSD = pm === "paypal" || pm === "tarjeta";

  return (
    <div id="orderSuccessSection">
    <div className="min-h-screen bg-gray-50 pt-32 pb-20 px-6 animate-fadeSlideIn">

      <div className="relative max-w-3xl mx-auto bg-white shadow-lg rounded-xl p-8">


        {/* 🌟 CHECK ANIMADO */}
        <div className="flex justify-center mb-6">
          <div className="w-20 h-20 rounded-full bg-green-500 flex items-center justify-center shadow-lg animate-fadeSlideIn">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-12 w-12 text-white"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth="2.5"
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
            </svg>
          </div>
        </div>

        {/* HEADER */}
        <div className="text-center mb-8 animate-fadeSlideIn" style={{ animationDelay: "0.1s" }}>
          <h1 className="text-3xl font-bold text-green-600">¡Pedido confirmado!</h1>
          <p className="text-gray-700 mt-2">
            Gracias por tu compra, tu pedido se ha realizado con éxito.
          </p>
        </div>

        {/* DETALLES DEL PEDIDO */}
        <div className="space-y-4 mb-8 animate-fadeSlideIn" style={{ animationDelay: "0.2s" }}>

          <div className="flex justify-between text-gray-700">
            <span className="font-semibold">Código de confirmación:</span>
            <span>{order.orderId}</span>
          </div>

          <div className="flex justify-between text-gray-700">
            <span className="font-semibold">Método de pago:</span>
            <span>{paymentMethod}</span>
          </div>

          {isColones && (
            <div className="flex justify-between text-gray-700">
              <span className="font-semibold">Total a pagar:</span>
              <span>₡{Number(total).toLocaleString()}</span>
            </div>
          )}

          {isUSD && (
            <>
              <div className="flex justify-between text-gray-700">
                <span className="font-semibold">Total en colones:</span>
                <span>₡{Number(total).toLocaleString()}</span>
              </div>

              <div className="flex justify-between text-gray-700">
                <span className="font-semibold">Total pagado (USD):</span>
                <span>${Number(totalUSD).toFixed(2)}</span>
              </div>
            </>
          )}

          <div className="flex justify-between text-gray-700">
            <span className="font-semibold">Cliente:</span>
            <span>{order.customerName}</span>
          </div>

          <div className="flex justify-between text-gray-700">
            <span className="font-semibold">Provincia:</span>
            <span>{order.stateId}</span>
          </div>

          <div className="flex justify-between text-gray-700">
            <span className="font-semibold">Cantón:</span>
            <span>{order.cantonId}</span>
          </div>

          <div className="flex justify-between text-gray-700">
            <span className="font-semibold">Distrito:</span>
            <span>{order.districtId}</span>
          </div>

          <div className="flex justify-between text-gray-700">
            <span className="font-semibold">Dirección:</span>
            <span>{order.address}</span>
          </div>

          <p className="text-sm text-gray-600 text-center mt-4">
            Si tienes alguna duda sobre tu pedido, escríbenos vía WhatsApp al{" "}
            <strong>8893-5779</strong>.
          </p>

          {/* Mostrar solo colones */} 
          {isColones && ( 
            <div className="flex justify-between text-gray-700"> 
                <p className="text-sm text-gray-600 text-center"> Una vez realizado el pago, <strong>recuerda enviar el comprobante</strong> vía WhatsApp al <strong>8893-5779</strong> y te estará llegando tu pedido a la dirección indicada entre <strong>24 a 48 horas de recibido el pago</strong> dentro del GAM, si estás fuera del GAM entre <strong>2 a 5 días hábiles</strong> y podrás darle seguimiento por medio de correos de Costa Rica. </p>
            </div> 
          )} 
            
          {/* Mostrar solo dólares */} 
          {isUSD && ( 
            <div className="flex justify-between text-gray-700"> 
                <p className="text-sm text-gray-600 text-center"> Tú pedido estará llegando a la dirección indicada entre 24 a 48 horas si estás dentro del GAM, fuera del GAM entre 2 a 5 días hábiles y podrás darle seguimiento por medio de correos de Costa Rica. </p> 
            </div> 
           )}
        </div>

        {/* PRODUCTOS */}
        <h3 className="text-xl font-semibold mb-4 animate-fadeSlideIn" style={{ animationDelay: "0.3s" }}>
          Productos del pedido
        </h3>

        <div className="space-y-4 animate-fadeSlideIn" style={{ animationDelay: "0.4s" }}>
          {items.map((item) => (
            <div key={item.id} className="flex border-b pb-3">
              <img
                src={item.image}
                className="w-16 h-16 rounded object-cover"
                alt=""
              />
              <div className="ml-4">
                <p className="font-semibold">{item.name}</p>
                <p className="font-semibold">{item.pack}</p>
                <p className="font-semibold">Cantidad: {item.quantity}</p>
              </div>
            </div>
          ))}
        </div>

        {/* BOTÓN FINAL */}
        <div className="text-center mt-10 animate-fadeSlideIn" style={{ animationDelay: "0.5s" }}>
          <Link
            to="/"
            className="px-6 py-3 bg-black text-white font-semibold rounded-lg hover:bg-[#d24e1e] transition"
          >
            Volver a la tienda
          </Link>
        </div>

      </div>
    </div>
    </div>
  );
}
